
const CryptoJS = require("crypto-js");
const Secretekey = "@#%resumes4hunt%#@_@#%CreatedBy%#@_@#%EspireSystem%#@";
const CryptoJSEncrypt = (plainText) => {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(plainText), Secretekey).toString();
    return encryptedData;
}
const CryptoJSDecrypt = (encryptedText) => {
    const bytes = CryptoJS.AES.decrypt(encryptedText, Secretekey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
}
const CryptoJSDecryptWithOutParse = (encryptedText) => {
    const bytes = CryptoJS.AES.decrypt(encryptedText, Secretekey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
}
const decryptApiData = (encValue) => {
    var decryptedText = null;
    try
    {
        var iv = CryptoJS.enc.Hex.parse("885D1E04AB1F4C7CDE10999B0AA864E9");
        var Pass = CryptoJS.enc.Utf8.parse("@Resumes$4%Hunt&Secrete&Key=90__%%");
        var Salt = CryptoJS.enc.Utf8.parse("@cryptography_#Resumes4Hunt_*salt_%_key9999");
        var key128Bits1000Iterations = CryptoJS.PBKDF2(Pass.toString(CryptoJS.enc.Utf8), Salt, { keySize: 128 / 32, iterations: 1000 });
        var cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(encValue)
        });
        var decrypted = CryptoJS.AES.decrypt(cipherParams, key128Bits1000Iterations, { mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7 });
        decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        return decryptedText;
    }
    catch (err) {
        return "";
    }
}
const AesEncryptForApi = (plainText) => {
    var key = CryptoJS.enc.Utf8.parse('8080919168684765');
    var iv = CryptoJS.enc.Utf8.parse('8888787678985577');
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypted.toString();
}
export const CryptoService = {
    CryptoJSEncrypt,
    CryptoJSDecrypt,
    CryptoJSDecryptWithOutParse
}